import AbstractEntryCommand from "./AbstractEntryCommand.js";
import DocumentNotificationSetting from "../DocumentNotificationSetting.js";
import optionsBag from "../../../options/optionsBag.js";
import selection from "../selection.js";

/**
 * `NotifyUsersCommand` is the command used to send notification to users for the current selection.
 * `NotifyUsersCommand` is valid if and only if one or multiple files are selected.
 */
export default class NotifyUsersCommand extends AbstractEntryCommand {
	constructor() {
		super(...arguments);

		this._users = [];
		this._customSetting = new DocumentNotificationSetting();
		this._hasCustomSettings = false;
	}

	getUsers() {
		return this._users.slice();
	}

	setUsers(usersList) {
		this._users = usersList.slice();
	}

	getCustomSetting() {
		if (this._hasCustomSettings) {
			this._hasCustomSettings = false;
			return this._customSetting;
		}
		return null;
	}

	setUserSelectedNotificationSettings(subject, body) {
		this._hasCustomSettings = true;
		this._customSetting.setNotificationSubject(subject);
		this._customSetting.setNotificationBody(body);
	}

	accept(aVisitor) {
		return aVisitor.visitNotifyUsersCommand(this);
	}

	priority() {
		return 900;
	}

	_performOnService() {
		this._documentService.executeNotifyUsersCommand(this);
	}

	static isApplicable() {
		const isDocumentArchiveNotificationEnabled = optionsBag
			.fromId("document-archive-notification")
			.isActive();

		return selection.notEmpty() && isDocumentArchiveNotificationEnabled;
	}
}
